import useInvestor from './useInvestor';

export default (accountId?: string) => {
  const {data: { isInvestmentModelSwitching }} = useInvestor(accountId );
  return isInvestmentModelSwitching;
};